import { WifiOff, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function OfflinePage() {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-background">
      <div className="text-center max-w-sm">
        {/* Offline icon */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-muted/50 flex items-center justify-center">
          <WifiOff className="h-10 w-10 text-muted-foreground" />
        </div>

        {/* Logo */}
        <img 
          src="/logo.png" 
          alt="VSU" 
          className="w-16 h-16 mx-auto mb-4 opacity-80"
        />

        {/* Title */}
        <h1 className="text-xl font-bold text-foreground mb-2 font-display">
          ইন্টারনেট সংযোগ নেই
        </h1>

        {/* Description */}
        <p className="text-sm text-muted-foreground mb-6">
          দুঃখিত, আপনি বর্তমানে অফলাইনে আছেন। অনুগ্রহ করে আপনার ইন্টারনেট সংযোগ পরীক্ষা করুন এবং আবার চেষ্টা করুন।
        </p>

        {/* Retry button */}
        <Button
          onClick={handleRetry}
          className="gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          আবার চেষ্টা করুন
        </Button>

        {/* Tips */}
        <div className="mt-8 p-4 bg-muted/30 rounded-xl text-left">
          <p className="text-xs text-muted-foreground mb-2 font-medium">
            টিপস:
          </p>
          <ul className="text-xs text-muted-foreground space-y-1">
            <li>• WiFi বা মোবাইল ডেটা চালু আছে কিনা দেখুন</li>
            <li>• এয়ারপ্লেন মোড বন্ধ আছে কিনা নিশ্চিত করুন</li>
            <li>• রাউটার রিস্টার্ট করে দেখুন</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
